import NewPost, { NewPostInternal } from './NewPost';

export default NewPost;
export { NewPostInternal };
